<template>
  <div >
    <div v-loading="loading" style="height:75vh;overflow-y: scroll">
      <div v-for="(item,index) in flowList" :key="index">
        <!-- 入职-->
        <div v-if="item.infoType=='0'" style="display:flex;">
          <div style="display:flex;">
            <div>
              <div class="item"></div>
              <div class="vertical"></div>
              <!--            <div class="item"></div>-->
            </div>
            <div style="width:100px;height:100px;margin-left: 10px">
              <div style="font-size: 16px; font-weight: 700">试工</div>
              <div style="font-size: 14px; color:#989898;">{{item.sortDate || ''}}</div>
            </div>
          </div>
          <el-descriptions :column="4" :colon="false">
            <el-descriptions-item :label-style="{'margin-left':'10px'}" label="应聘渠道：" >{{item.userProbationInfo.applyChannelName || ''}}</el-descriptions-item>
            <el-descriptions-item :label-style="{'margin-left':'10px'}" label="推荐人/渠道名称：" >{{item.userProbationInfo.applyChannelDesc || ''}}</el-descriptions-item>
            <!--          <el-descriptions-item :label-style="{'margin-left':'10px'}" label="外部渠道名称：" >kooriookami</el-descriptions-item>-->
            <el-descriptions-item :label-style="{'margin-left':'10px'}" label="应聘店铺：" >{{item.userProbationInfo.marketName || ''}}</el-descriptions-item>
            <el-descriptions-item :label-style="{'margin-left':'10px'}" label="应聘职级：" >{{item.userProbationInfo.postName || ''}}</el-descriptions-item>
            <el-descriptions-item :label-style="{'margin-left':'10px'}" label="试工日期：" >{{item.userProbationInfo.probationDateStart || ''}}</el-descriptions-item>
            <el-descriptions-item :label-style="{'margin-left':'10px'}" label="试工结果：" >{{item.userProbationInfo.probationStateDesc || ''}}</el-descriptions-item>
            <el-descriptions-item :label-style="{'margin-left':'10px'}" label="未通过原因：" :span="2" v-if="item.userProbationInfo.probationState=='-12' || item.userProbationInfo.probationState=='-10'">
              <el-tooltip effect="dark" :content="item.userProbationInfo.probationReason" placement="top-start" v-if="item.userProbationInfo.probationReason">
                <div style="width:500px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                  {{item.userProbationInfo.probationReason}}
                </div>
              </el-tooltip>
            </el-descriptions-item>
          </el-descriptions>
        </div>
        <!-- 转正-->
        <div v-if="item.infoType=='1'" style="display:flex;">
          <div style="display:flex;">
            <div>
              <div class="item"></div>
              <div class="vertical"></div>
              <!--<div class="item"></div>-->
            </div>
            <div style="width:100px;height:100px;margin-left: 10px">
              <div style="font-size: 16px; font-weight: 700">转正</div>
              <div style="font-size: 14px; color:#989898;">2024-09-12</div>
            </div>
          </div>
          <el-descriptions :column="4" :colon="false">
            <el-descriptions-item :label-style="{'margin-left':'10px'}" label="拟定转正日期：" >{{item.userEntryInfo.planHiredDate || ''}}</el-descriptions-item>
            <el-descriptions-item :label-style="{'margin-left':'10px'}" label="实际转正日期：" >{{item.userEntryInfo.hiredDate || ''}}</el-descriptions-item>
            <el-descriptions-item ></el-descriptions-item>
            <el-descriptions-item ></el-descriptions-item>
            <el-descriptions-item :label-style="{'margin-left':'10px'}" label="转正说明：" :span="2">
              <el-tooltip effect="dark" :content="item.userEntryInfo.regularizationRemark" placement="top-start" v-if="item.userEntryInfo.regularizationRemark">
                <div style="width:800px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                  {{item.userEntryInfo.regularizationRemark}}
                </div>
              </el-tooltip>
            </el-descriptions-item>
          </el-descriptions>
        </div>
        <!-- 培训-->
        <div v-if="item.infoType=='4'" style="display:flex;">
          <div style="display:flex;">
            <div>
              <div class="item"></div>
              <div class="vertical"></div>
              <!--            <div class="item"></div>-->
            </div>
            <div style="width:100px;height:100px;margin-left: 10px">
              <div style="font-size: 16px; font-weight: 700">培训</div>
              <div style="font-size: 14px; color:#989898;">{{item.sortDate || ''}}</div>
            </div>
          </div>
          <div style="background-color: #f3f3f5;height:80px; width:100%;border-radius: 10px;padding:10px; display:flex;">
            <div style="width:220px;text-align: center;margin-top:10px">
              <div style="font-weight:700;font-size: 15px">{{item.userBusinessTrainingRecode.sourceMarket || ''}}</div>
              <div style="color:#989898;font-size: 14px">原店铺</div>
            </div>
            <div style="text-align: center">
              <div style="display:flex;margin-top:5px;">
                <div style="width:80px;background-color: #d9d9d9;height:5px;margin-top:10px;"></div>
                <el-tag size="small" type="info" >{{item.userBusinessTrainingRecode.trainType || ''}}</el-tag>
                <div style="width:80px;background-color: #d9d9d9;height:5px;margin-top:10px;"></div>
              </div>
              <div style="color:#989898;font-size: 14px">{{item.userBusinessTrainingRecode.startTime || ''}} 至 {{item.userBusinessTrainingRecode.endTime || ''}}</div>
            </div>
            <div style="width:220px;text-align: center;margin-top:10px">
              <div style="font-weight:700;font-size: 15px">{{item.userBusinessTrainingRecode.targetMarket || ''}}</div>
              <div style="color:#989898;font-size: 14px">培训部门</div>
            </div>
            <div style="font-size: 15px;display: flex;padding:20px 0 0 30px;color:#606266">
              培训理由：
              <el-tooltip effect="dark" :content="item.userBusinessTrainingRecode.remark" placement="top-start" v-if="item.userBusinessTrainingRecode.remark">
                <div style="width:380px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                  {{item.userBusinessTrainingRecode.remark}}
                </div>
              </el-tooltip>
            </div>
          </div>
        </div>
        <!-- 调岗-->
        <div v-if="item.infoType=='5'" style="display:flex;">
          <div style="display:flex;">
            <div>
              <div class="item"></div>
              <div class="vertical"></div>
              <!--<div class="item"></div>-->
            </div>
            <div style="width:100px;height:100px;margin-left: 10px">
              <div style="font-size: 16px; font-weight: 700">调岗</div>
              <div style="font-size: 14px; color:#989898;">{{item.sortDate || ''}}</div>
            </div>
          </div>
          <div style="background-color: #f3f3f5;height:80px; width:100%;border-radius: 10px;padding:10px; display:flex;">
            <div style="width:220px;text-align: center;margin-top:10px">
              <div style="font-weight:700;font-size: 15px">{{item.userTrainRecode.sourceMarket || ''}}</div>
              <div style="color:#989898;font-size: 14px">{{item.userTrainRecode.sourcePost || ''}}</div>
            </div>
            <div style="text-align: center">
              <div style="display:flex;margin-top:5px;">
                <div style="width:80px;background-color: #d9d9d9;height:5px;margin-top:10px;"></div>
                <el-tag size="small" v-if="item.userTrainRecode.trainType==='降职'" type="danger" >{{'降职'}}</el-tag>
                <el-tag size="small" v-if="item.userTrainRecode.trainType==='升职'" >{{'升职'}}</el-tag>
                <el-tag size="small" v-if="item.userTrainRecode.trainType==='平调'" type="info" >{{'平调'}}</el-tag>
                <div style="width:80px;background-color: #d9d9d9;height:5px;margin-top:10px;"></div>
              </div>
              <div style="color:#989898;font-size: 14px">新部门负责人：{{item.userTrainRecode.isPrincipalDesc || ''}}</div>
            </div>
            <div style="width:220px;text-align: center;margin-top:10px">
              <div style="font-weight:700;font-size: 15px">{{item.userTrainRecode.targetMarket || ''}}</div>
              <div style="color:#989898;font-size: 14px">{{item.userTrainRecode.targetPost || ''}}</div>
            </div>
            <div style="padding:5px 50px">
              <div style="font-size: 14px;color:#606266;margin-bottom:10px;">申请时间：{{item.userTrainRecode.applyTime || ''}}</div>
              <div style="font-size: 14px;color:#606266">生效时间：{{item.userTrainRecode.effectiveTime || ''}}</div>
            </div>
          </div>
        </div>
        <!-- 出差-->
        <div v-if="item.infoType=='3'" style="display:flex;">
          <div style="display:flex;">
            <div>
              <div class="item"></div>
              <div class="vertical"></div>
              <!--            <div class="item"></div>-->
            </div>
            <div style="width:100px;height:100px;margin-left: 10px">
              <div style="font-size: 16px; font-weight: 700">出差</div>
              <div style="font-size: 14px; color:#989898;">{{item.sortDate || ''}}</div>
            </div>
          </div>
          <div style="background-color: #f3f3f5;height:80px; width:100%;border-radius: 10px;padding:10px; display:flex;">
            <div style="width:220px;text-align: center;margin-top:10px">
              <div style="font-weight:700;font-size: 15px">{{item.userTripRecode.sourceMarket || ''}}</div>
              <div style="color:#989898;font-size: 14px">原店铺</div>
            </div>
            <div style="text-align: center">
              <div style="display:flex;margin-top:5px;">
                <div style="width:80px;background-color: #d9d9d9;height:5px;margin-top:10px;"></div>
                <el-tag size="small" type="info" >{{'出差'}}</el-tag>
                <div style="width:80px;background-color: #d9d9d9;height:5px;margin-top:10px;"></div>
              </div>
              <div style="color:#989898;font-size: 14px">{{item.userTripRecode.startTime || ''}} 至 {{item.userTripRecode.endTime || ''}}</div>
            </div>
            <div style="width:220px;text-align: center;margin-top:10px">
              <div style="font-weight:700;font-size: 15px">{{item.userTripRecode.targetMarket || ''}}</div>
              <div style="color:#989898;font-size: 14px">出差部门</div>
            </div>
            <div style="font-size: 15px;display: flex;padding:20px 0 0 50px;color:#606266">
              出差理由：
              <el-tooltip effect="dark" :content="item.userTripRecode.remark" placement="top-start" v-if="item.userTripRecode.remark">
                <div style="width:400px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                  {{item.userTripRecode.remark}}
                </div>
              </el-tooltip>
            </div>
          </div>
        </div>
        <!-- 离职-->
        <div v-if="item.infoType=='2'" style="display:flex;">
          <div style="display:flex;">
            <div>
              <div class="item"></div>
              <div class="vertical"></div>
              <!--            <div class="item"></div>-->
            </div>
            <div style="width:100px;height:100px;margin-left: 10px">
              <div style="font-size: 16px; font-weight: 700">离职</div>
              <div style="font-size: 14px; color:#989898;">{{item.sortDate || ''}}</div>
            </div>
          </div>
          <el-descriptions :column="4" :colon="false">
            <el-descriptions-item :label-style="{'margin-left':'10px'}" label="离职原因：" >{{item.userResignInfo.leaveReasonDesc || ''}}</el-descriptions-item>
            <el-descriptions-item :label-style="{'margin-left':'10px'}" label="计划离职日期：" >{{item.userResignInfo.leavePlanTime || ''}}</el-descriptions-item>
            <el-descriptions-item :label-style="{'margin-left':'10px'}" label="实际离职日期：" >{{item.userResignInfo.finalLeaveTime || ''}}</el-descriptions-item>
            <el-descriptions-item ></el-descriptions-item>
            <el-descriptions-item :label-style="{'margin-left':'10px'}" label="具体原因：" :span="4">
              <el-tooltip effect="dark" :content="item.userResignInfo.userReason" placement="top-start" v-if="item.userResignInfo.userReason">
                <div style="width:500px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                  {{item.userResignInfo.userReason}}
                </div>
              </el-tooltip>
            </el-descriptions-item>
          </el-descriptions>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import newPostUrl from '@/libs/http/modules/oa.js'

export default {
  name:'flowTrack',
  props: ['record'],
  data() {
    return {
       flowList:[],
       loading:false,
    }
  },
  created() {
    console.log('record=======', this.record)
  },
  watch:{
    record:{
      handler(newValue){
        if(this.record){
          this.fetch()
        }
      },
      deep:true,
      immediate:true
    }
  },
  methods: {
    fetch(){
      this.loading = true
      this.$emit("loadingUserInfo",true);
      newPostUrl.queryUserShopAssistantWorkRecodeList({userId: this.record.userId}).then((res)=>{
        this.flowList = res
        this.loading = false
        this.$emit("loadingUserInfo",false);
      }).catch((error)=>{
        this.loading = false
        this.$emit("loadingUserInfo",false);
        if(error.msg){
          this.$message.error(error.msg)
        }else{
          this.$message.error(error)
        }
        console.log(error)
      })
    },


  },
}
</script>

<style lang="scss" scoped>
  .item{
    border:2px solid #0b83f3;
    border-radius: 50%;
    height:20px;
    width:20px;
  }
  .vertical{
    height:80px;
    width:2px;
    margin-left: 9px;
    background-color:#0b83f3;
  }
  ::v-deep .el-descriptions__body{
    background-color: #f3f3f5;
    height:80px;
    padding:10px;
    border-radius: 10px;
  }
</style>